import {
  withTranslation,
} from 'react-i18next';

import ResultPosDialogView from './ResultPosDialogView';

const TranslatedComponent = withTranslation()(ResultPosDialogView);

const Component = TranslatedComponent;

export default Component;
